import { LangProvider } from "@/app/providers/LangProvider";
import { ReactContextProvider } from "@/app/providers/ReactContextProvider";
import { RouterProvider } from "@/app/providers/RouterProvider";
import { QueryProvider } from "@/app/providers/QueryProvider";

export function App() {
  return (
    <ReactContextProvider>
      <LangProvider>
        <QueryProvider>
          <RouterProvider />
        </QueryProvider>
      </LangProvider>
    </ReactContextProvider>
  );
}
